<template>
  <div class="s-overlap-strips__strip">
    <div class="s-overlap-strips__conts">
      <div class="s-overlap-strips__row">
        <div class="s-wizard__results__txt s-wizard__results__txt--graph">
          <h2 class="s-wizard__results__txt__header">
            {{ data.title }}
          </h2>
          <div class="s-wizard__results__txt__wrp">
            <div class="s-wizard__results__txt__left">
              <div class="s-wizard__results__txt__box">
                <h3>{{ data.profileTitle }}</h3>
                <p v-html="data.profileText"></p>
              </div>
            </div>
            <div class="s-wizard__results__txt__right">
              <div class="s-wizard__results__txt__box">
                <h3>{{ data.portfolioTitle }}</h3>
                <div class="s-graphic__wrap">
                  <doughnutChart
                    :chart-data="data.portfolioGraph"></doughnutChart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import doughnutChart from './../charts/chart-doughnut-legend-card.vue'

export default {
  components: {
    doughnutChart,
  },
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
}
</script>
